import { createApp } from "vue";
import "@okta/okta-auth-js/polyfill";
import { setupI18n } from "./i18n";
import App from "./App.vue";
import { setupRouter } from "./router";
import en from "./locales/en.json";

const i18n = setupI18n({
  legacy: true,
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
  },
});

const router = setupRouter(i18n);

createApp(App)
  .use(router)
  .use(i18n)
  .mount("#app");
